import { TTranslationData } from "@propely/propely-typings";
import { z } from "zod";

export const TRawDataType = z.object({
  id: z.string(),
  name: TTranslationData,
  options: z.record(
    z.object({
      name: TTranslationData,
    })
  ),
});

export type IRawDataType = z.infer<typeof TRawDataType>;

